
<ul>
    @for( doc of data; track $index) {
        <li><a [routerLink]="getNavRoute(doc)">{{doc.title}}</a></li>
    }
</ul>
